/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';
angular.module('bulbApp.badgesModule', ['ui.router', 'bulbApp.authModule', 'bulbApp.configModule',
  'bulbApp.utilsModule', 'bulbApp.authorModule'])
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state('badges', {
        parent: 'author',
        url: '^/{username:[^/?.]{2,}}/badges',
        resolve: {
          $title: ['$translate', ($translate) => $translate('badges_title')],
          userBadgeInfo: ['authorAccount', 'Restangular', function(authorAccount, Restangular) {
            return Restangular.one('accounts', authorAccount.id).one('badges').get()
              .then(function(badges) {
                return badges;
              });
          }]
        },
        views: {
          'badgeDetails': {
            templateUrl: 'ajs/components/badge/badgecontainer.html',
            controller: 'BadgeContainerController as badgeContainerCtrl'
          }
        },
        onEnter: ['$state', 'BulbAuthService', 'authorAccount', 'userBadgeInfo', function($state, BulbAuthService, authorAccount, userBadgeInfo) {
          // Tests if the user accessing the page is the owner of the badges page or not.
          // If it is the user, allow them through, if not, give them a 404 if there are no badges.
          if ((BulbAuthService.currentUser.id !== authorAccount.id && !userBadgeInfo) ||
            !authorAccount.hasBadges) {
            $state.go('notFound', {}, {location: false});
          }
        }],
      });
  }]);
